import React, { useEffect, useState } from "react"
import Observations from "../../../../common/Fhir/Observation"
import ImmunizationList from "../../../../common/Fhir/ImmunizationList"
import ConditionList from "../../../../common/Fhir/ConditionList"
import Encounter from "../../../../common/Fhir/Encounter"
import CarePlan from "../../../../common/Fhir/CarePlan"
import Person from "../../../../common/Fhir/Person"
import ResourceList from "../../../../common/Fhir/ResourceList"
import {
    getPatientName,
    getPatientPhone,
    getPatientEmail,
    getPatientHomeAddress,
    getPatientAge,
    getPath,
    getPatientMRN,
    getAllPages
} from "."
import "./PatientDetail.less"
import { useData } from "@pure-ptr/react"
import { fetchResources, GetPatientDetails } from "../../../../store/api/fhir-api"
import { Backdrop,  CircularProgress, Dialog, DialogTitle, Grid, IconButton, Modal, Tooltip } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { getPatientFhirDbData, importPatientFhirData } from "../../../../store/api/claimAnalysis"
import { toast } from "react-toastify"

export const gridStyles = {
  wrapper: {
    maxHeight: 500,
    border: "1px solid #ddd",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column"
  },
  body: {
    flex: 1,
    overflowY: "auto"
  },
  content: {
    minWidth: "100%",
    width: "max-content"
  }
};

/**
 * Renders the detail page.
 */
export const PatientDetail = (props: any) => {
    const { claimId, isOpen, handleClose, isFhirConfigured } = props;
    const [groups, setGroups] = useState<any>({});
    const [selectedSubCat, setSelectedSubCat] = useState<any>();
    const [patient, setPatient] = useState<any>();    
    const [isImport, setIsImport] = React.useState<boolean>();
    const [loading, setLoading] = useState(false);
    const [selectedResources, setSelectedResources] = useState<Record<string, boolean>>({});

    const getResourceKey = (resource: { id?: string; resourceType?: string }) => {
        if (!resource || !resource.id) {
            return "";
        }
        const type = resource.resourceType || "";
        return `${type}:${resource.id}`;
    };

    useEffect(() => {
    if (isOpen) {
        setPatient(null);
        setGroups({});
        //setSelectedSubCat(null);
        setLoading(true);
    }
}, [isOpen, claimId]);

    const {
        isPending,
     } = useData(async () => {
        try {
            if (claimId && isFhirConfigured && isOpen) {
                setLoading(true);
                const response = await GetPatientDetails(claimId);
                const result = await getAllPages(response, '','');
                
                if (result) {
                    const patientDetail = getPath(response, `entry.${0}.resource`);
                    if (patientDetail) {

                        const selectedData = await getFhirData(claimId);
                        
                        setPatient(patientDetail);

                        const observations = await fetchResources('/api/v1/Observation/', patientDetail.id);
                        if (observations) {
                            const processedObservation = await getAllPages(observations,'/api/v1/Observation/', patientDetail.id);
                            processedObservation.forEach(observation => {
                                result.push(observation)
                            });
                        }

                        const conditions = await fetchResources('/api/v1/Condition/', patientDetail.id);
                        if (conditions) {
                            const processedCondition =await  getAllPages(conditions, '/api/v1/Condition/', patientDetail.id);
                            processedCondition.forEach(condition => {
                                result.push(condition)
                            });
                        }

                        const diagnosticReports = await fetchResources('/api/v1/DiagnosticReport/', patientDetail.id);
                        if (diagnosticReports) {
                            const processedDiagnosticReport = await getAllPages(diagnosticReports, '/api/v1/DiagnosticReport/', patientDetail.id);
                            processedDiagnosticReport.forEach(diagnosticReport => {
                                result.push(diagnosticReport)
                            });
                        }

                        const encounters = await fetchResources('/api/v1/Encounter/', patientDetail.id);
                        if (encounters) {
                            const processedEncounter = await getAllPages(encounters, '/api/v1/Encounter/', patientDetail.id);
                            processedEncounter.forEach(encounter => {
                                result.push(encounter)
                            });
                        }

                        const documentReferences = await fetchResources('/api/v1/DocumentReference/', patientDetail.id);
                        if (documentReferences) {
                            const processedDocumentReferences = await getAllPages(documentReferences, '/api/v1/DocumentReference/', patientDetail.id);
                            processedDocumentReferences.forEach(documentReference => {
                                result.push(documentReference)
                            });
                        }

                        let tempGroups = {};
                        const initialSelected: Record<string, boolean> = {};
                        result.forEach(entry => {
                            let resourceType = getPath(entry, "resource.resourceType") || "Other";
                            let type = resourceType;

                            if (type == "Observation") {
                                let subCat = String(
                                    getPath(entry, "resource.category.0.text") ||
                                    getPath(entry, "resource.category.coding.0.code") ||
                                    getPath(entry, "resource.category.0.coding.0.code") ||
                                    "Other"
                                ).toLowerCase();

                                subCat = subCat.split(/\-+/).map(token => {
                                    return token.charAt(0).toUpperCase() + token.substr(1)
                                }).join(" ");
                                type += " - " + subCat;
                            }

                            if (!Array.isArray(tempGroups[type])) {
                                tempGroups[type] = []
                            }
                            if (entry.resource) {
                                const selected = selectedData.find(x => x.resourceId == entry.resource.id && x.resourceType == entry.resource.resourceType);
                                if (selected) {
                                    entry.resource.isSelected = true;
                                    const key = getResourceKey(entry.resource);
                                    if (key) {
                                        initialSelected[key] = true;
                                    }
                                }
                            }
                            tempGroups[type].push(entry)
                        })

                        if (!selectedSubCat || !tempGroups[selectedSubCat]) {
                            setSelectedSubCat(Object.keys(tempGroups)[0] || "")
                        }
                        
                        setGroups(tempGroups);
                        setSelectedResources(initialSelected);
                    }
                }
                return response;
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }

    }, [claimId, isFhirConfigured, isOpen]);

    const {
        reload: runImport,
        isPending: importLoading,
        error
    } = useData(async () => {
        if(!isImport) return null;
        const payload = buildImportPayload(claimId);
        
        try {
            const res = await importPatientFhirData(payload,claimId);
            
            if (res === "Success") {
                toast.success("Saved Successfully.", {
                    autoClose: 3000,
                });
            }
        } catch (error) {
            toast.error("Save failed. Please try again.", {
                autoClose: 3000,
            });
        }
        finally{
            setIsImport(false);
            handleClose();
        }
    });

    const getFhirData = async (claimId) => {
        let response = [];
        try {

            response = await getPatientFhirDbData(claimId);

        } catch {
            toast.error("Failed to get FHIR data. Please try again.", {
                autoClose: 3000,
            });
        }
        finally {
            return response;
        }
    }

    const syncSelectionInGroups = (currentGroups: any, resourceId: string, isChecked: boolean) => {
        const updatedGroups = { ...currentGroups };

        Object.keys(updatedGroups).forEach(type => {
            const items = updatedGroups[type];
            if (!Array.isArray(items)) {
                return;
            }

            items.forEach((item: any) => {
                const resource = item.resource ?? item;
                if (resource && resource.id === resourceId) {
                    resource.isSelected = isChecked;
                }
            });
        });

        return updatedGroups;
    };

    const updateSelectedResources = (resource: any, isChecked: boolean) => {
        const key = getResourceKey(resource);
        if (!key) {
            return;
        }

        setSelectedResources(prev => {
            const next = { ...prev };
            if (isChecked) {
                next[key] = true;
            } else {
                delete next[key];
            }
            return next;
        });
    };

    const buildImportPayload = (claimId: string) => {
        const getResource = (item: { resource?: any }) => item.resource ?? item;

        return Object.entries(groups).flatMap(([type, resources]) =>
            (resources as any[]).map((item) => {
                const resource = getResource(item);

                if (resource.isSelected) {
                    return {
                        claimId: claimId,
                        resourceId: resource.id,
                        resourceType: resource.resourceType || type,
                        attachmentType:resource?.content?.[0]?.attachment?.contentType,
                        attachmentData:resource?.content?.[0]?.attachment?.data ?? ""
                    };
                }
                return null;
            }).filter((payload) => payload !== null)
        );
    };

    const handleGlobalSelectionChange = (row, isChecked) => {
        if (!row || !row.id) {
            return;
        }

        updateSelectedResources(row, isChecked);
        setGroups(prevGroups => syncSelectionInGroups(prevGroups, row.id, isChecked));
    };

    const handleImportClick = async () => {
        setIsImport(true);
        runImport();
    };


    const renderPatient = () => {
        return (
            <div className="panel panel-default patient col-xs-12">
                <div className="row">
                    <div className="col-xs-10 col-md-11">
                        <div className="patient-row">
                            <div className="col-xs-7 patient-name">
                                <h3 className="pull-left text-primary">
                                    {getPatientName(patient) || "Unknown"}
                                </h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Gender:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {patient.gender || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">DOB:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {patient.birthDate || "Unknown"}
                            </div>

                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Age:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {getPatientAge(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Email</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientEmail(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Phone:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {getPatientPhone(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Address:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientHomeAddress(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">ID:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {patient.id || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">MRN:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientMRN(patient) || "Unknown"}
                            </div>
                            {
                                patient.deceasedBoolean || patient.deceasedDateTime ?
                                    (
                                        <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">
                                            <span className="deceased-label">Deceased:</span>
                                        </div>
                                    ) :
                                    null
                            }
                            {
                                patient.deceasedBoolean || patient.deceasedDateTime ?
                                    (
                                        <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                            {
                                                patient.deceasedDateTime ?
                                                    <span>{patient.deceasedDateTime}</span> :
                                                    <span>{patient.deceasedBoolean ? "Yes" : "No"}</span>
                                            }
                                        </div>
                                    ) :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    const handleSelectionChange = (type, row, isChecked) => {
        if (!row || !row.id) {
            return;
        }

        updateSelectedResources(row, isChecked);
        setGroups(prevGroups => syncSelectionInGroups(prevGroups, row.id, isChecked));
        setSelectedSubCat(type);
    };

    const renderResources = (type) => {
        let items = groups[type] || [];
        if (!items.length) {
            return (
                <p className="text-center text-muted">
                    No items of type "{type}" found
                </p>
            )
        }

        const commonProps = {
            resources: items,
            onSelectionChange: (row, checked) =>
                handleSelectionChange(type, row, checked),
        };

        if (type.indexOf("Observation") === 0) {
            return <Observations {...commonProps} />;
        }

        switch (type) {
            case "Immunization":
                return <ImmunizationList {...commonProps} />;
            case "Condition":
                return <ConditionList {...commonProps} />
            case "Encounter":
                return (
                    <Encounter
                        {...commonProps}
                        patientId={patient.id}
                        selectedResources={selectedResources}
                        onGlobalSelectionChange={handleGlobalSelectionChange}
                    />
                );
            case "CarePlan":
                return <CarePlan {...commonProps} />;
            case "Patient":
            case "Practitioner":
            case "RelatedPerson":
                return <Person {...commonProps} title={type} />;
            default:
                return <ResourceList {...commonProps} type={type} />;
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={isOpen} onClose={handleClose}
            PaperProps={{
                sx: {
                    minHeight: !loading && !isPending && !patient ? "0vh" : "20vh",
                },
            }}>
            <DialogTitle>
                <Grid container alignItems='center'>
                    <Grid item xs={10}>
                        {'Patient Details'}
                    </Grid>
                    <Grid item xs={2} className='text-right'>
                        {!loading && !isPending && patient && (
                        <Tooltip title="Save">
                            <IconButton aria-label="close" onClick={handleImportClick} size="large">
                                <SaveIcon />
                            </IconButton>
                        </Tooltip>
                        )}
                        <IconButton aria-label="close" onClick={handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>        
                    </Grid>
                </Grid>
            </DialogTitle>

                    {/* No Data */}
                    {!loading && !isPending && !patient && (
                        <div style={{justifyContent: "center", display: "flex", paddingBottom: "20px",}}>
                            No details for this patient
                        </div>
                    )}

                    <Backdrop
                        open={Boolean(importLoading) || Boolean(isPending)}
                        sx={{
                            zIndex: 9999,
                            color: "#fff",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                         <div style={{ marginTop: "50px" }}>
                            <CircularProgress size={35} thickness={2} color="secondary" />
                        </div>
                    </Backdrop>
                    
                    {/* Data */}
                    {!loading && !isPending && patient && (
                        <div className="page patient-detail-page">
                            <div className="container">

                                {renderPatient()}

                                {Object.keys(groups || {}).length > 0 ? (
                                    <div
                                        className="row patient-details"
                                        style={{ paddingTop: '20px' }}
                                    >
                                        <br />

                                        <div className="col-xs-12 col-sm-3">
                                            <ul className="list-group">
                                                {Object.keys(groups)
                                                    .sort()
                                                    .map((k, i) => (
                                                        <a
                                                            href="#"
                                                            key={i}
                                                            className={
                                                                "list-group-item" +
                                                                (k === selectedSubCat ? " active" : "")
                                                            }
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedSubCat(k);
                                                            }}
                                                        >
                                                            <b className="badge pull-right">
                                                                {groups[k]?.length || 0}
                                                            </b>
                                                            <b>{k}</b>
                                                        </a>
                                                    ))}
                                            </ul>
                                        </div>

                                        <div className="col-xs-12 col-sm-9">
                                            {selectedSubCat
                                                ? renderResources(selectedSubCat)
                                                : null}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-xs-12 text-muted text-center">
                                            No additional details for this patient
                                        </div>
                                    </div>
                                )}
                            </div>
                                        
                        </div>
                    )}
        </Dialog>
    )
}

export default PatientDetail;
